/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationSummarySchema = z.object({
  countryCode: z.string(),
  id: z.int(),
  subdivisionCode: z.string().nullish(),
});
